import React from "react";

import GxHorizontalLine from "../../components/common/actions/buttons/GxHorizontalLine";
import GxDeleteRedButton from "../../components/common/actions/buttons/GxDeleteRedButton";
import GxResendButton from "../../components/common/actions/buttons/GxResendButton";
import GxButton from "../../components/common/actions/buttons/GxButton"; // Import GxButton instead

interface DialogInviteUsersFooterProps {
  handleFooterSubmit: (e?: React.FormEvent) => void;
  onDeleteClick?: () => void;
  onResendClick?: () => void;
  label: string;
  label1?: string;
  submit: string;
  disable?: boolean;
  hideBTN?: boolean;
  isSubmitting?: boolean;
  HorizontalLine?: boolean;
}

const DialogInviteUsersFooter: React.FC<DialogInviteUsersFooterProps> = ({
  handleFooterSubmit,
  onDeleteClick,
  onResendClick,
  label,
  label1,
  submit,
  disable,
  hideBTN,
  isSubmitting = false,
  HorizontalLine,
}) => {
  const handleClick = () => {
    if (onDeleteClick !== undefined) {
      onDeleteClick();
    }
  };

  return (
    <div className="gx-dialog-actions">
      {hideBTN ? (
        <>
          {HorizontalLine && <GxHorizontalLine />}
          <div className="flex space-x-2">
            {label1 && (
              <GxDeleteRedButton onClick={handleClick} disabled={isSubmitting}>
                {label1}
              </GxDeleteRedButton>
            )}
            <GxResendButton
              label={label}
              onResendClick={onResendClick}
              disabled={isSubmitting}
            />
            <GxButton
              variant="filled" // Use filled variant for primary button style
              onClick={handleFooterSubmit}
              disabled={disable || isSubmitting}
              type="submit" // Set type to submit
              bgColor="var(--primaryColor)" // Match the primary color
              textColor="white" // White text
              // Optional: add className for additional styling if needed
              className="uppercase"
            >
              {isSubmitting ? "Submitting..." : submit}
            </GxButton>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default DialogInviteUsersFooter;
